module.exports = __webpack_public_path__ + "img/elantra4.ca6f132d.jpeg";